import { apiRequest } from "../client/httpClient";

export const authRegister = (payload) =>
  apiRequest("/auth/register", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const authLogin = (payload) =>
  apiRequest("/auth/login", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const authMe = () => apiRequest("/auth/me");

export const authLogout = () =>
  apiRequest("/auth/logout", {
    method: "POST",
    body: JSON.stringify({}),
  });

export const authCheckEmail = (email) =>
  apiRequest(`/auth/check-email?email=${encodeURIComponent(email)}`);







